module.exports = __webpack_public_path__ + "static/media/case4.ff1658c1.jpg";